function o(n) {
  return n.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
function u(n) {
  return n.replace(/[０-９]/g, (t) => String.fromCharCode(t.charCodeAt(0) - 65248)).replace(/[－ー−]/g, "-").replace(/，/g, ",").replace(/．/g, ".");
}
function a(n, t = !0) {
  n = u(n);
  const r = t && /^\s*-/.test(n), e = n.split(".", 1)[0].replace(/[^\d]/g, "");
  return e ? (r ? "-" : "") + e.replace(/^0+(?=\d)/, "") : r ? "-" : "";
}
function f(n) {
  var e;
  if (n == null || n === "") return "";
  const t = typeof n == "number" ? String(n) : n.trim(), r = /^(-?)(\d+)(\.\d+)?$/.exec(t);
  return r ? r[1] + o(r[2]) + ((e = r[3]) != null ? e : "") : t;
}
function m(n) {
  const t = a(n);
  if (t === "" || t === "-") return;
  const r = Number(t);
  return Number.isFinite(r) ? r : void 0;
}
function l(n) {
  return n.toLocaleString("ja-JP");
}
function g(n) {
  return n == null ? "—" : n.toLocaleString("ja-JP");
}
function d(n) {
  return n == null ? "" : n.toLocaleString("ja-JP");
}
const c = ["JPY", "KRW", "VND", "CLP", "ISK", "UGX", "PYG"];
function s(n) {
  return n && c.indexOf(n.toUpperCase()) >= 0 ? 0 : n ? 2 : 0;
}
function i(n, t) {
  if (n == null) return "-";
  const r = s(t);
  return n.toLocaleString("ja-JP", { style: "decimal", minimumFractionDigits: r, maximumFractionDigits: r });
}
function p(n) {
  return n ? `(${n})` : "";
}
function D(n, t) {
  const r = i(n, t);
  return t && n != null ? `${r} ${t}` : r;
}
function N(n) {
  return i(n);
}
function P(n) {
  return n ? n.slice(0, 16).replace("T", " ") : "—";
}
export {
  a,
  m as b,
  s as c,
  P as d,
  i as e,
  f,
  D as g,
  l as h,
  d as i,
  g as j,
  N as k,
  p as m,
  u as t
};
